"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlayerId = isPlayerId;
exports.isGameId = isGameId;
exports.isSpectatorId = isSpectatorId;
exports.isSpaceId = isSpaceId;
exports.safeCast = safeCast;
function isPlayerId(object) {
    return object?.charAt?.(0) === 'p';
}
function isGameId(object) {
    return object?.charAt?.(0) === 'g';
}
function isSpectatorId(object) {
    return object?.charAt?.(0) === 's';
}
function isSpaceId(object) {
    return /^m?[0-9][0-9]$/.test(object);
}
function safeCast(object, tester) {
    if (tester(object)) {
        return object;
    }
    throw new Error('failed cast: ' + tester.name);
}
